import React from 'react'

function GreetSection() {
    return (
        <React.Fragment>
            <div className="greetings" id="greetings">
                <div className="greet-inner">
                    <div className="row justify-content-center row-greet">
                        <div className="greet-second col-sm-12 col-xl-8">
                            <br /><br />
                            <h2 className="greet-title">"TO THE COMPUTER SOCIETY WHERE EVERYONE LIVES TOGETHER"</h2>
                            <h3>創る人、使う人。 誰もが共存するコンピュータ社会へ</h3>
                            <br /><br />
                            <h4>皆様へ</h4>
                            <p>平素は格別のご支援を賜り、厚くお礼申し上げます。</p>

                            <p>
                                今日、少子高齢化とともに若年労働者人口の減少状態が今後も続いていくと予想され、それに伴い国境も時間も越えたボーダレス社会が全世界的に進んでおります。
                                弊社においてもこのような時代の流れに対応すべく、積極的なグローバル化を進めております。
                            </p>

                            <p>また、技術革新の面においてもＩｏＴ・ロボット・ＡＩ・ビッグデータといった社会の在り方に影響を及ぼす新たな技術の進展が進んできており、
                                社会全般も一定の時間経過と供に一変すると思われます。
                                それに必要不可欠なソフトウェア開発面において弊社は積極的に先端技術を追求していかねばなりません。</p>

                            <p>
                                弊社においてこの二つの流れをしっかりと追求した上で、弊社の特徴としての医療ソフトウェア分野、
                                セキュリテイソフトウェア分野をさらに進化させて行く所存でございます。これらの事柄に真剣に取り組んでいき、
                                当社の経営目標である「お客様の経営に貢献する」こと、「お客様の永続的なビジネスパートナーを目指す」こと、また、
                                「従業員が未来を託せる企業」たるべく努力してまいります。
                            </p>

                            <p>
                                このような取り組みを通して、厳しい競争時代を生き抜く力強い組織と、専門知識・業務知識の豊富な、
                                創造的で活力に満ちた人材を育成して、お客様により高い付加価値を提供できる企業を目指し、邁進してまいります。
                            </p>

                            <p>
                                今後とも何とぞ、格別のご理解とご支援を賜りますようお願い申し上げます。
                            </p>

                            {/* <p>今後とも何とぞ、格別のご理解とご支援を賜りますようお願い申し上げます。</p> */}

                            <p className="ceo-name">
                                代表取締役社長<br />
                                高橋 徹
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default GreetSection
